import React from 'react';
import PropTypes from 'prop-types';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import appI18n from '../i18n';
import ConnectedApp from './App';
import NavigationConfirmationHost from './common/NavigationConfirmationHost';

export default function Root({ store, history }) {
    return (
      <Provider store={store}>
        <I18nextProvider i18n={appI18n}>
          <NavigationConfirmationHost />
          <ConnectedRouter history={history}>
            <ConnectedApp />
          </ConnectedRouter>
        </I18nextProvider>
      </Provider>
    );
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
